import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "../lib/cn.js";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  readonly required?: boolean;
};

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, required, children, ...rest },
  ref,
) {
  return (
    <label
      ref={ref}
      className={cn("text-base font-medium text-fg", className)}
      {...rest}
    >
      {children}
      {required === true ? (
        <span aria-hidden="true" className="ml-0.5 text-danger">
          *
        </span>
      ) : null}
    </label>
  );
});
